import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditCommunityLayer from "../components/EditFreeCommunityLayer";
 
 
const EditCommunityPage = () => {
  return (
    <>

        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Free Community  </h5><Breadcrumb title="Edit Free Community" /></div>
 
        {/* CalendarMainLayer */}
        <EditCommunityLayer />
 
 
    </>
  );
};
 
export default EditCommunityPage;
 
 